import { useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import Enums from 'constants/componentData/fmsEnums';

const dataSource = source => {
  const sources = Enums.dataSource;
  switch (source) {
    case sources.caps:
      return 'CAPS';
    case sources.cnc:
      return 'Payroll';
    case sources.ms:
      return 'MediaServices';
    default:
      return `Data Source ${source}`;
  }
};

const useStyles = makeStyles(({ palette }) => ({
  root: {
    cursor: 'pointer',
    borderLeft: '5px solid transparent',
    fontSize: 14,
    color: palette.cncUI.primary.gray['+0'],
    padding: '18px 20px 20px 15px !important',
  },
  label: {
    margin: 0,
  },
  date: {
    textAlign: 'right',
  },
  bold: { fontWeight: 'bold' },
  hover: {
    color: palette.cncUI.default.primary,
  },
  selected: {
    color: palette.cncUI.default.primary,
    borderLeft: `5px solid ${palette.cncUI.default.primary}`,
  },
  light: {
    backgroundColor: palette.cncUI.default['+9'],
  },
  dark: {
    backgroundColor: palette.cncUI.default['+7'],
  },
}));

const Item = props => {
  const classes = useStyles();
  const { index, selected = false } = props;
  const { onClick = () => {}, profile } = props;
  const [hover, setHover] = useState(false);
  const boldClassName = clsx((hover || selected) && classes.bold);
  const rootClassName = clsx(
    classes.root,
    classes[index % 2 ? 'light' : 'dark'],
    selected && classes.selected,
  );
  const textClassName = type =>
    clsx(
      classes.label,
      type && classes[type],
      (hover || selected) && classes.hover,
    );
  const { firstName, middleInitial, lastName, dbCode } = profile.basicInfo;
  const fullName = [firstName, middleInitial, lastName]
    .filter(Boolean)
    .join(' ');
  const keyId = (field = null) => `ListItem${index}${field ? field : ''}`;

  return (
    <Grid
      item
      xs={12}
      onClick={() => onClick(profile, index)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      id={keyId()}
    >
      <Grid container spacing={1} className={rootClassName}>
        <Grid item xs={12}>
          <Typography
            variant="body2"
            className={textClassName()}
            id={keyId('name')}
          >
            {fullName}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography className={textClassName()} id={keyId('search')}>
            <span className={boldClassName}>DB Code: </span>
            {dbCode || 'N/A'}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography className={textClassName()} id={keyId('from')}>
            <span className={boldClassName}>From: </span>
            {dataSource(profile.dataSource)}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Item;
